import { render, staticRenderFns } from "./DrawerList.vue?vue&type=template&id=23259582&scoped=true&"
import script from "./DrawerList.vue?vue&type=script&lang=js&"
export * from "./DrawerList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23259582",
  null
  
)

export default component.exports